import { render, staticRenderFns } from "./LHeader.vue?vue&type=template&id=f97c0ac4&scoped=true"
import script from "./LHeader.vue?vue&type=script&lang=js"
export * from "./LHeader.vue?vue&type=script&lang=js"
import style0 from "./LHeader.vue?vue&type=style&index=0&id=f97c0ac4&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f97c0ac4",
  null
  
)

export default component.exports